import { PICS_URL } from "api";
import AddOrLinkButton from "components/AddOrLinkButton";
import InputSelect from "components/InputSelect";
import Counter2 from "components/counter2";
import CalculatorPackichQuote from "components/quote/packich_quote";
import { ROUTES_PATHS } from 'const';
import { useStores } from "hooks/useStores";
import { format_price } from "js/utils";
import React, { useEffect, useRef, useState } from "react";
import Price from './components/Price';

const Package = () => {
  const [count, setCount] = useState(1);
  const [countPacks, setCountPacks] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFetchedAdd, setIsFetchedAdd] = useState(false);
  const [items, setItems] = useState({});
  const [fetch, setFetch] = useState(1);
  const [width, setWidth] = useState(1);
  const [defaultWidth, setDefaultWidth] = useState(1);
  const [length, setLength] = useState(1);
  const [defaultLength, setDefaultLength] = useState(1);
  const [thickness, setThickness] = useState(1);
  const [defaultThickness, setDefaultThickness] = useState(1);

  const { api, cartStore } = useStores();

  const { addCartItem } = cartStore

  useEffect(() => {
    setIsLoaded(false);
    setIsLoadedTShirt(false);
    setIsLoadedZip(false);

    api.catalog
      .getPackageCalc({
        width: width,
        length: length,
        thickness: thickness,
      })
      .then((response) => {
        setItems(response);
        for (let item of response.width) {
          if (item.is_active === true) {
            setDefaultWidth(item);
          }
        }
        for (let item of response.length) {
          if (item.is_active === true) {
            setDefaultLength(item);
          }
        }
        for (let item of response.thickness) {
          if (item.is_active === true) {
            setDefaultThickness(item);
          }
        }
        setIsLoaded(true);
      });
  }, [fetch]);

  const widthHandler = (value) => {
    setWidth(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedTShirt) {
      setFetchTShirt(fetchTShirt + 1);
    }
    if (isLoadedZip) {
      setFetchZip(fetchZip + 1);
    }
    resetCounters();
    restartButton();
  };

  const lengthHandler = (value) => {
    setLength(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedTShirt) {
      setFetchTShirt(fetchTShirt + 1);
    }
    if (isLoadedZip) {
      setFetchZip(fetchZip + 1);
    }
    resetCounters();
    restartButton();
  };

  const thicknessHandler = (value) => {
    setThickness(value.value);
    if (isLoaded) {
      setFetch(fetch + 1);
    }
    if (isLoadedTShirt) {
      setFetchTShirt(fetchTShirt + 1);
    }
    if (isLoadedZip) {
      setFetchZip(fetchZip + 1);
    }
    resetCounters();
    restartButton();
  };

  const [isLoadedTShirt, setIsLoadedTShirt] = useState(false);
  const [fetchTShirt, setFetchTShirt] = useState(1);

  const mounted = useRef(true);
  useEffect(() => {
    if (mounted.current) {
      // do componentDidMount logic
      mounted.current = false;
    } else {
      // do componentDidUpdate logic
      setIsLoaded(false);
      setIsLoadedTShirt(false);
      setIsLoadedZip(false);

      api.catalog
        .getPackageTShirtCalc({
          width: width,
          length: length,
          thickness: thickness,
        })
        .then((response) => {
          setItems(response);
          for (let item of response.width) {
            if (item.is_active === true) {
              setDefaultWidth(item);
            }
          }
          for (let item of response.length) {
            if (item.is_active === true) {
              setDefaultLength(item);
            }
          }
          for (let item of response.thickness) {
            if (item.is_active === true) {
              setDefaultThickness(item);
            }
          }
          setIsLoadedTShirt(true);
        });
    }
  }, [fetchTShirt]);

  const [isLoadedZip, setIsLoadedZip] = useState(false);
  const [fetchZip, setFetchZip] = useState(1);

  const mounted2 = useRef(true);
  useEffect(() => {
    if (mounted2.current) {
      // do componentDidMount logic
      mounted2.current = false;
    } else {
      // do componentDidUpdate logic
      setIsLoaded(false);
      setIsLoadedTShirt(false);
      setIsLoadedZip(false);

      api.catalog
        .getPackageZipLockCalc({
          width: width,
          length: length,
          thickness: thickness,
        })
        .then((response) => {
          setItems(response);
          for (let item of response.width) {
            if (item.is_active === true) {
              setDefaultWidth(item);
            }
          }
          for (let item of response.length) {
            if (item.is_active === true) {
              setDefaultLength(item);
            }
          }
          for (let item of response.thickness) {
            if (item.is_active === true) {
              setDefaultThickness(item);
            }
          }
          setIsLoadedZip(true);
        })
        .catch((error) => {
          if (error.response.status === 500) {
          }
        });
    }
  }, [fetchZip]);

  const radioHandler = (e) => {
    let radio1 = document.querySelector("#radio-1");
    let radio2 = document.querySelector("#radio-2");
    let radio3 = document.querySelector("#radio-3");

    if (e.target.id === "radio-1" && isLoaded === true) {
      return;
    } else if (e.target.id === "radio-2" && isLoadedTShirt === true) {
      return;
    } else if (e.target.id === "radio-3" && isLoadedZip === true) {
      return;
    }
    if (radio1.checked === true) {
      setFetch(fetch + 1);
      document.querySelector(".calc-right__title").innerHTML =
        "Фасовочные пакеты";
    } else if (radio2.checked === true) {
      setFetchTShirt(fetchTShirt + 1);
      document.querySelector(".calc-right__title").innerHTML = `Пакет "Майка"`;
    } else if (radio3.checked === true) {
      setFetchZip(fetchZip + 1);
      document.querySelector(
        ".calc-right__title"
      ).innerHTML = `Пакет "Зип-лок"`;
    }
    resetCounters();
    restartButton();
  };

  const resetCounters = () => {
    setCount(items.multiplicity);
    setCountPacks(1);
  };

  const resetHandler = () => {
    document.querySelector("#radio-1").checked = true;
    resetCounters();
    setWidth(1);
    setLength(1);
    setThickness(1);
    setFetch(fetch + 1);
    setIsAdd(false);
  };

  const restartButton = () => {
    setIsAdd(false);
  };

  const [isAdd, setIsAdd] = useState(false);
  const postItem = () => {
    if (items.in_pack_count === 1) {
      setCountPacks(0);
    }
    setIsFetchedAdd(true);

    addCartItem({
      product_article: items.article,
      item_quantity: count,
      package_quantity: countPacks,
    })
    .then(() => {
      setIsFetchedAdd(false);
      setIsAdd(true);
    });
  };


  useEffect(() => {
    if (isLoaded) {
      setCount(items.multiplicity);
    }
  }, [isLoaded]);

  useEffect(() => {
    if (isLoadedZip) {
      setCount(items.multiplicity);
    }
  }, [isLoadedZip]);

  useEffect(() => {
    if (isLoadedTShirt) {
      setCount(items.multiplicity);
    }
  }, [isLoadedTShirt]);

  const [isLoadedCounters, setIsLoadedCounters] = useState(false);
  const [restartCounters, setRestartCounters] = useState(1);

  useEffect(() => {
    setIsLoadedCounters(true);
  }, [restartCounters]);

  const countRef = useRef(true);
  const isCountUpdates = useRef(true);
  useEffect(() => {
    if (countRef.current) {
      // do componentDidMount logic
      countRef.current = false;
    } else {
      if (count === 0) {
        setCount(items.multiplicity);
        return;
      }
      if (count / items.in_pack_count === countPacks) {
        return;
      }

      isCountUpdates.current = false;
      setCountPacks(Math.ceil(count / items.in_pack_count));
    }
  }, [count]);

  const countPackRef = useRef(true);
  useEffect(() => {
    if (countPackRef.current) {
      // do componentDidMount logic
      countPackRef.current = false;
    } else {
      // do componentDidUpdate logic
      if (isCountUpdates.current) {
        setCount(countPacks * items.in_pack_count);
      }
      isCountUpdates.current = true;
      setIsLoadedCounters(false);
      setRestartCounters(restartCounters + 1);
    }
  }, [countPacks]);

  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  useEffect(() => {
    if (isLoaded) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (isLoadedZip) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoadedZip]);

  useEffect(() => {
    if (isLoadedTShirt) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoadedTShirt]);


  let slideIndex = 1;
  function showSlides(slideIndex) {
    let sliderSize = document.querySelector(".how-gallery-slider").clientWidth;
    const slides = document.querySelectorAll(
      ".how-gallery-slider__slides-item"
    );
    for (let slide of slides) {
      slide.style.transform = `translateX(-${(slideIndex - 1) * sliderSize}px)`;
    }

    const dots = document.querySelectorAll(".controls-dots-dot");
    for (let dot of dots) {
      dot.classList.remove("controls-dots-dot-active");
    }
    dots[slideIndex - 1].classList.add("controls-dots-dot-active");
  }

  useEffect(() => {
      if (document.querySelectorAll(".controls-dots-dot").length !== 0) {
        const dots = document.querySelectorAll(".controls-dots-dot");
        if (dots.length === 1) {
          document.querySelector(
            ".how-gallery-slider__controls"
          ).style.display = "none";
        }
        const click = (i) => {
          slideIndex = i + 1;
          showSlides(slideIndex);
        };
        dots[0].classList.add("controls-dots-dot-active");
        for (let i = 0; i < dots.length; i++) {
          const dot = dots[i];
          dot.addEventListener("click", () => click(i));
        }
        let backBtn = document.querySelector("#backBtn");
        backBtn.addEventListener("click", back);
        let frvBtn = document.querySelector("#frvBtn");
        frvBtn.addEventListener("click", frv);
    }
  }, []);

  const back = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === 1) {
        slideIndex = dots.length;
      } else {
        slideIndex -= 1;
      }
      showSlides(slideIndex);
  };

  const frv = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === dots.length) {
        slideIndex = 1;
      } else {
        slideIndex += 1;
      }
      showSlides(slideIndex);
  };

  return (
    <div className='calculator-main-content-calc'>
      <div className='calc-setings'>
        <div className='calc-settings-wrap'>
          <ul className='calc-settings__list'>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title radio-title'>Вид:</p>
              <div className='calc-settings__list-item-setting radio-settings-wrap'>
                <div className='radio-settings'>
                  {isLoaded || isLoadedTShirt || isLoadedZip ? (
                    <>
                      <div className='form_radio'>
                        <input
                          id='radio-1'
                          type='radio'
                          name='radio'
                          value='1'
                          onClick={(e) => radioHandler(e)}
                          defaultChecked={isLoaded}
                        />
                        <label htmlFor='radio-1'>Фасовочные пакеты</label>
                      </div>
                      <div className='form_radio'>
                        <input
                          id='radio-2'
                          type='radio'
                          name='radio'
                          value='1'
                          onClick={(e) => radioHandler(e)}
                          defaultChecked={isLoadedTShirt}
                        />
                        <label htmlFor='radio-2'>Майки</label>
                      </div>
                      <div className='form_radio'>
                        <input
                          id='radio-3'
                          type='radio'
                          name='radio'
                          value='1'
                          onClick={(e) => radioHandler(e)}
                          defaultChecked={isLoadedZip}
                        />
                        <label htmlFor='radio-3'>Зип-локи</label>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className='radio-loader' />
                      <div className='radio-loader' />
                      <div className='radio-loader' />
                    </>
                  )}
                </div>
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Ширина, см:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedTShirt || isLoadedZip ? (
                  <InputSelect
                    defaultValue={defaultWidth}
                    options={items.width}
                    onchangeInput={widthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Длина, см:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedTShirt || isLoadedZip ? (
                  <InputSelect
                    defaultValue={defaultLength}
                    options={items.length}
                    onchangeInput={lengthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Толщина, мкм:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded || isLoadedTShirt || isLoadedZip ? (
                  <InputSelect
                    defaultValue={defaultThickness}
                    options={items.thickness}
                    onchangeInput={thicknessHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            {(!isLoaded && !isLoadedTShirt && !isLoadedZip) ||
            items.in_pack_count === 1 ? null : (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.package_count_text !== ""
                    ? items.page_data.package_count_text
                    : "Количество, уп:"}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter1"}
                    onChange={setCountPacks}
                    multiplicity={items.multiplicity}
                    count={countPacks}
                    minCount={1}
                    step={1}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            )}
            {isLoaded || isLoadedTShirt || isLoadedZip ? (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.count_text !== ""
                    ? items.page_data.count_text
                    : "Количество, шт:"}
                  {items.in_pack_count === 1 ? null : (
                    <span className='tooltip'>
                      <span className='tooltiptext'>
                        {items.page_data.package_count_hint !== ""
                          ? items.page_data.package_count_hint
                          : `1 упаковка = ${items.in_pack_count} штук(и)`}
                      </span>
                    </span>
                  )}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter2"}
                    onChange={setCount}
                    count={count}
                    minCount={items.multiplicity}
                    step={items.multiplicity}
                    multiplicity={items.multiplicity}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            ) : null}
            <li className='calc-settings__list-item mobile-list-item'>
              <p className='calc-settings__list-item-title'>Наличие:</p>
              {items.in_stock === "в наличии" ||
              items.in_stock === "В наличии" ? (
                <div className='calc-settings__list-item-setting settings-stock'>
                  {items.in_stock}
                </div>
              ) : (
                <div className='calc-settings__list-item-setting settings-outOfStock'>
                  {items.in_stock}
                </div>
              )}
            </li>
            <Price minPrice={minPrice} maxPrice={maxPrice} />

            <li className='calc-settings__list-item calc-border'>
              <div className='calc-settings-border'></div>
            </li>
            <li className='calc-settings__list-item  calc-cart'>
              <button
                className='calc-settings__button-reset'
                onClick={resetHandler}
              >
                <div className='button-reset-icon'></div>
                <div className='button-reset-title'>Сбросить</div>
              </button>
              <AddOrLinkButton
                isAdd={isAdd}
                postItem={postItem}
                isFetchedAdd={isFetchedAdd}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className='calc-right'>
        <div className='calc-right__content'>
          {items.image ? (
            <div className='calc-right__img'>
              <img loading="lazy" src={PICS_URL + items.image} alt={items.title || ''} />
            </div>
          ) : null}
          <h3 className='calc-right__title'>Фасовочные пакеты</h3>
          <table className='calc-right__table'>
            <tbody>
              <tr>
                <th>Артикул</th>
                <td>{items.article}</td>
              </tr>
              <tr>
                <th>Техническое название</th>
                <td>{items.title}</td>
              </tr>
              {items.color ? (
                <tr>
                  <th>Цвет</th>
                  <td>{items.color}</td>
                </tr>
              ) : null}
            </tbody>
          </table>
          {items?.page_data?.pak_pakych_quote ? (
            <CalculatorPackichQuote
              text={items.page_data.pak_pakych_quote.text}
              bgColor={items.page_data.pak_pakych_quote.bg_color}
              borderColor={items.page_data.pak_pakych_quote.border_color}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default Package;
